"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.BACKGROUND_COLOR_CSS_PROPERTY = void 0;
var _tss = require("../styles/tss");
const BACKGROUND_COLOR_CSS_PROPERTY = exports.BACKGROUND_COLOR_CSS_PROPERTY = '--_HighlightedCardWrapper-color-background';
const useStyles = exports.useStyles = _tss.tss.create(_ref => {
  let {
    theme
  } = _ref;
  const {
    colors,
    spacing,
    styles
  } = theme.busbud;
  const panelPadding = 0.5;
  return {
    root: {
      display: 'grid',
      alignContent: 'start',
      rowGap: spacing(panelPadding),
      borderRadius: styles.rounding.xl,
      // TODO: use the default `Card` rounding token when it's added
      outline: `
        ${spacing(panelPadding)}
        solid
        var(${BACKGROUND_COLOR_CSS_PROPERTY})
      `,
      backgroundColor: `var(${BACKGROUND_COLOR_CSS_PROPERTY})`,
      '& > *': {
        position: 'relative' // Ensure that children are at a higher level to avoid having the outline hiding shadows
      }
    },
    colorInformative: {
      [BACKGROUND_COLOR_CSS_PROPERTY]: colors.background.informative.transparent
    },
    colorNegative: {
      [BACKGROUND_COLOR_CSS_PROPERTY]: colors.background.negative.transparent
    },
    colorNeutral: {
      [BACKGROUND_COLOR_CSS_PROPERTY]: colors.background.secondary.transparent
    },
    colorNotice: {
      [BACKGROUND_COLOR_CSS_PROPERTY]: colors.background.notice.transparent
    },
    colorPositive: {
      [BACKGROUND_COLOR_CSS_PROPERTY]: colors.background.positive.transparent
    },
    colorSpecial: {
      [BACKGROUND_COLOR_CSS_PROPERTY]: colors.background.special.transparent
    }
  };
});